import callAPI from 'api'

import {
  CreateTeamPayload,
  CreateTeamResponse,
  DeleteTeamPayload,
  DeleteTeamResponse,
  ExportTeamsResponse,
  GetTeamPayload,
  GetTeamResponse,
  GetTeamMemberLookupResponse,
  GetTeamsPayload,
  GetTeamsResponse,
  UpdateTeamPayload,
  UpdateTeamResponse,
} from './types/team'

export const createTeam = async (payload: CreateTeamPayload) =>
  await callAPI<CreateTeamResponse, CreateTeamPayload>('crm_create_team', [payload], {
    requireAuthorization: true,
    reloadOnReauth: false,
  })

export const deleteTeam = async (payload: DeleteTeamPayload) =>
  await callAPI<DeleteTeamResponse, DeleteTeamPayload>('crm_delete_team', [payload], {
    requireAuthorization: true,
    reloadOnReauth: false,
  })

export const exportTeams = async () =>
  await callAPI<ExportTeamsResponse>('crm_download_team_to_excel', undefined, { requireAuthorization: true })

export const getTeam = async (payload: GetTeamPayload) =>
  await callAPI<GetTeamResponse, GetTeamPayload>('crm_get_team_details', [payload], { requireAuthorization: true })

export const getTeamMemberLookup = async (payload: GetTeamPayload) =>
  await callAPI<GetTeamMemberLookupResponse, GetTeamPayload>('crm_get_team_member_lookup', [payload], {
    requireAuthorization: true,
  })

export const getTeams = async (payload: GetTeamsPayload) =>
  await callAPI<GetTeamsResponse, GetTeamsPayload>('crm_get_teams', [payload], { requireAuthorization: true })

export const updateTeam = async (payload: UpdateTeamPayload) =>
  await callAPI<UpdateTeamResponse, UpdateTeamPayload>('crm_update_team', [payload], {
    requireAuthorization: true,
    reloadOnReauth: false,
  })
